<template>
  <div>
    <v-dialog
      v-model="isVisibleProp"
      :max-width="dialogDynamicWidth"
      @keydown.enter="isCanSaveOrClose($event)"
      persistent
      scrollable
    >
      <v-card :height="dialogDynamicHeight">
        <v-card-title>
          <v-tabs
          v-model="handleTabChange"
          @click="handleTabChange(itemMenu.id)"
          height="25px">
          <v-tab v-for="itemMenu in tabsList" :key="itemMenu.id" class="common-font-size"
          :style="{'color':itemMenu.color}">
            {{ itemMenu.tab }}
          </v-tab>
          <span v-if="dialogHeaderName" class="common-font-size">
            {{ `${editedItem._id ? "Edit" : "Add"} ${dialogHeaderName}` }}
          </span>
          <span v-if="onlyDialogHeaderName" class="common-font-size">
            {{ onlyDialogHeaderName }}
          </span>
          <v-spacer></v-spacer>
              <v-icon @click="close" color="error" v-if="canCancel">
                {{ icons.mdiWindowClose }}
              </v-icon>
            </v-tabs>
      </v-card-title>
        <!-- <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title> -->

        <v-card-text class="pt-2">
          <v-form v-model="isValidProp.value" ref="form"
          :lazy-validation="true">
            <slot name="editedItem">
              <v-container>
                <!-- you should always override to show how to edit the item -->
                <span>(this is the default template)</span>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem._id"
                      label="ID"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </slot>
          </v-form>
        </v-card-text>

        <v-card-actions id="tmc-base-crud-actions">
          <v-btn v-if="canDeleteInDialog"
          :class="`input-text-size`"
          text color="error darken-1"
          @click="deleteRecord"
          >Delete</v-btn>
          <slot name="additionalActionsAfterDelete"/>
          <v-spacer></v-spacer>
          <slot name="additionalActions"/>
          <v-btn v-if="canCancel"
            id = "crud-closing-btn"
            :class="`tmc-base-crud-${canSave ? 'cancel' : 'close'} input-text-size`"
            text color="blue darken-1"
            @click="close"
          >{{canSave ? 'Cancel' : 'Close'}}</v-btn>
          <v-btn v-if="canApply"
            :class="`input-text-size`"
            text color="blue darken-1"
            @click="apply"
          >Apply</v-btn>
          <v-btn v-if="canSave"
            :class="`input-text-size`"
            text color="blue darken-1"
            @click="(e)=>saveOnClick(e)"
            >{{canSaveCustomLabel}}</v-btn>
          <slot name="additionalActionsAfterSave"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiContentSave,
  mdiWindowClose,
} from '@mdi/js';
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import { enterBelongsToFocusedControl, flushFocusedField } from '../../../../util/shared/vue-global';

export default {
  name: 'CRUDDialog',
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'default',
    },
    dialogHeaderName: {
      type: String,
      default: '',
    },
    onlyDialogHeaderName: {
      type: String,
      default: '',
    },
    dialogDynamicWidth: {
      type: String,
      default: '70vw',
    },
    // Empty by default so the card keeps growing to fit its content - only the dialogs
    // that ask for it get a fixed height. Vuetify caps .v-dialog at 90% of the viewport,
    // so anything above '90vh' just overflows the dialog and pushes the action buttons
    // out of sight; '90vh' is the tallest usable value.
    dialogDynamicHeight: {
      type: String,
      default: '',
    },
    canSave: {
      type: Boolean,
      default: true,
    },
    canSaveCustomLabel: {
      type: String,
      default: 'Save',
    },
    canDeleteInDialog: {
      type: Boolean,
      default: false,
    },
    canApply: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: true,
    },
    // Only consulted when canSave is false. A canSave=false dialog has no built-in
    // Save button because the host renders its own in the additionalActions slots
    // (the Tax Inquiry record dialog does), so the default Enter behaviour - close and
    // throw the record away - silently discards everything the user just typed. Such a
    // host passes :closeOnEnter="false" and acts on @crudDialogEnter instead.
    closeOnEnter: {
      type: Boolean,
      default: true,
    },
    overrideValidation: {
      type: Boolean,
      default: false,
    },
    tabsList: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    icons: {
      mdiContentSave,
      mdiWindowClose,
    },
    // isValidProp: false,
    tab: 0,
    isSaving: false,
  }),
  watch: {
    isVisibleProp: {
      immediate: true,
      handler(val) {
        if (val) {
          window.addEventListener('keydown', this.handleEscKey);
        } else {
          window.removeEventListener('keydown', this.handleEscKey);
        }
      },
    },
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEscKey);
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'index',
      'isVisible',
      'selectedTab',
      'isValidFormProp',
      'topDialog',
    ]),
    // dialogTitle() {
    //   if (this.canSave === false) {
    //     return 'Item';
    //   }
    //   return this.index(this.baseCrudKey) === -1 ? 'New Item' : 'Edit Item';
    // },
    isVisibleProp: {
      get() {
        return this.isVisible(this.baseCrudKey);
      },
      set(value) {
        this.setIsVisible([this.baseCrudKey, value]);
      },
    },
    isValidProp: {
      get() {
        return this.isValidFormProp(this.baseCrudKey);
      },
      set(value) {
        this.setIsValidFormProp([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    handleTabChange: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setItem',
      'setSelectedTab',
      'setIsValidFormProp',
    ]),
    validateForm() {
      // makes the red UI validators show up
      return this.$refs.form.validate();
    },
    handleEscKey(e) {
      if (e.key === 'Escape' && this.baseCrudKey === this.topDialog) this.close();
    },
    close(force = false) {
      if (!force && !this.canCancel) return;
      // this is used to reset the form valiadation
      this.isVisibleProp = false;
      this.setSelectedTab([this.baseCrudKey, 0]);
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.$emit('crudDialogClose');
        if (this.$refs.form) {
          this.$refs.form.reset(); // this will reset the form after everything is done
        }
      });
    },
    // Enter does not belong to the dialog when the control under the cursor has its
    // own meaning for it - a focused button/link keeps it here, which is how the status
    // code, fees, comments and payment dialogs get opened from inside the record.
    enterBelongsToFocusedControl(e) {
      return enterBelongsToFocusedControl(e);
    },
    async isCanSaveOrClose(e) {
      if (e && e.repeat) return;
      if (this.enterBelongsToFocusedControl(e)) return;
      // The dialog is acting on this keystroke, so nothing else may - see the same
      // guard in crud v1 CRUDDialog.handleEnterKey. Without it the keystroke outlives
      // the dialog and lands on whatever VDialog restores focus to (the list's Add (+)
      // button), opening a blank record right after the saved one.
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
      // A focused v-combobox has not committed its typed text yet (see
      // flushFocusedField) - flush it before validating/emitting the record.
      await flushFocusedField(this);
      this.validateForm();
      this.$emit('crudDialogEnter', this.editedItem);
      if (this.canSave) this.save();
      else if (this.closeOnEnter) this.close(true);
    },
    saveOnClick(e) {
      // this 'e.detail' if its 1 then its mouse click else its keyboard click
      if (e.detail) this.save();
    },
    async save(withClose = true) {
      if (this.isSaving) return;
      this.isSaving = true;
      // A focused v-combobox has not written the user's latest keystrokes into
      // editedItem yet - it only commits once the component itself is told to blur
      // (see flushFocusedField). Flush before validating and reading the record,
      // otherwise the typed value is dropped.
      await flushFocusedField(this);
      this.validateForm();
      // setTimeOut is needed sometimes without validating form is saving, that leads to error
      setTimeout(() => {
        if (this.overrideValidation) {
          this.$emit('upsertItem', this.editedItem);
          if (withClose) this.close(true);
        } else if (!this.isValidProp.value) {
          this.$emit('invalidItem', this.isValidProp.value);
        } else {
          this.$emit('upsertItem', this.editedItem);
          if (withClose) this.close(true);
        }
        this.isSaving = false;
      }, 100);
    },
    deleteRecord() {
      if (this.isValidProp.value) {
        this.$emit('deleteItem', this.editedItem);
      }
    },
    apply() {
      return this.save(false);
    },
  },
};
</script>
